import { PrivacyPolicy } from '@gjl/ui'
import { useSEO } from '@/hooks/useSEO'

export default function PrivacyPage() {
  useSEO({
    title: 'Privacy Policy',
    description:
      'How Fugue Lab handles your data. We use analytics cookies only and never sell your personal information.',
    url: '/privacy',
    canonical: '/privacy',
  })

  return (
    <PrivacyPolicy
      orgName="Fugue Lab"
      operator="Garrett John Law, Sherman Oaks, California"
      contactEmail="hello@fuguelab.com"
      siteUrl="https://fuguelab.com"
      analyticsProvider="Google Analytics 4"
      lastUpdated="September 19, 2026"
      smsProgram={{
        name: 'Fugue Lab sign-in codes by text',
        purpose: 'a one-time code each time you sign in, and one to confirm your number',
        termsPath: '/sms-terms',
      }}
    />
  )
}
